import { InputNumber } from 'antd'
import styled from 'styled-components'

const StyledInputNumber = styled(InputNumber).attrs({
  min: 0 as any, // dont know why error
})`
  &.ant-input-number {
    border-radius: 4px;
    background-color: ${p => p.theme.input.bg};
    border-color: ${p => p.theme.input.borderColor};
    color: ${p => p.theme.input.color};
    &.ant-input-number-disabled {
      background-color: ${p => p.theme.input.disabledBg};
      color: ${p => p.theme.input.disabledColor};
    }
  }

  &.ant-input-number-focused,
  &.ant-input-number:focus,
  &.ant-input-number:hover {
    border-color: ${p => p.theme.input.hoverAndFocusBorderColor};
  }

  &.ant-input-number-focused,
  &.ant-input-number:focus {
    box-shadow: none;
  }
`

export default StyledInputNumber
